(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["upc-catalog-filters"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('upc-catalog-filters')){
 customElements.define('upc-catalog-filters',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const parts=location.pathname.split('/').filter(Boolean);
   const collectionIndex=parts.indexOf('collections');
   if(collectionIndex>=0){
    const base='/'+parts.slice(0,collectionIndex+2).join('/');
    const tags=(parts[collectionIndex+2]||'').split('+').filter(Boolean).map(tag=>decodeURIComponent(tag));
    this.querySelectorAll('select').forEach(select=>{
     const group=select.id.endsWith('-brand')?'brand':'type';
     const prefix='upc-'+group+'-';
     const kept=tags.filter(tag=>!tag.startsWith(prefix));
     Array.from(select.options).forEach((option,index)=>{
      const tag=index?decodeURIComponent(new URL(option.value,location.origin).pathname.split('/').pop().split('+').pop()):null;
      const next=tag?[...kept,tag]:kept;
      option.value=base+(next.length?'/'+next.map(value=>encodeURIComponent(value)).join('+'):'');
      option.selected=tag?tags.includes(tag):!tags.some(value=>value.startsWith(prefix));
     });
    });
   }
   this.addEventListener('input',event=>event.stopPropagation());
   this.addEventListener('change',event=>{
    event.stopPropagation();
    if(event.target.tagName!=='SELECT')return;
    const target=new URL(event.target.value,location.origin);
    target.search=location.search;
    target.searchParams.delete('page');target.searchParams.delete('section_id');
    location.assign(target.href);
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["upc-infinite-scroll"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('upc-infinite-scroll')){
 customElements.define('upc-infinite-scroll',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;
   this.ready=true;this.loading=false;this.done=false;
   this.button=this.querySelector('a');this.status=this.querySelector('[role="status"]');
   this.button.addEventListener('click',e=>{e.preventDefault();this.loadNext(true);});
   if(!this.dataset.nextUrl){this.button.hidden=true;return;}
   if('IntersectionObserver' in window){
    this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))this.loadNext(false);},{rootMargin:'350px 0px'});
    this.observer.observe(this);
   }
  }
  disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();}
  async loadNext(manual){
   if(this.loading||this.done||!this.dataset.nextUrl||!this.isConnected)return;
   this.loading=true;this.controller=new AbortController();this.setAttribute('aria-busy','true');
   this.status.textContent=this.dataset.loading;this.button.setAttribute('aria-disabled','true');
   try{
    const next=new URL(this.dataset.nextUrl,location.href);
    next.searchParams.set('section_id',this.dataset.sectionId);
    const response=await fetch(next.toString(),{signal:this.controller.signal});
    if(!response.ok)throw new Error('page');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const incoming=doc.querySelector('#product-grid'),grid=this.closest('#ProductGridContainer')?.querySelector('#product-grid');
    if(!incoming||!grid||!this.isConnected)throw new Error('grid');
    const cards=Array.from(incoming.children);
    if(!cards.length)throw new Error('empty');
    grid.append(...cards);
    const following=doc.querySelector('upc-infinite-scroll')?.dataset.nextUrl||'';
    this.dataset.nextUrl=following;
    this.button.href=following||'#';this.button.hidden=!following;
    this.status.textContent=following?'':this.dataset.end;
    this.done=!following;
    if(manual){const link=cards[0].querySelector('a');if(link)link.focus({preventScroll:true});}
    if(this.done)this.observer?.disconnect();
    else{this.observer?.unobserve(this);requestAnimationFrame(()=>{if(this.isConnected)this.observer?.observe(this);});}
   }catch(error){
    if(error.name!=='AbortError'){this.status.textContent=this.dataset.error;this.button.hidden=false;this.observer?.disconnect();}
   }finally{this.loading=false;this.removeAttribute('aria-busy');this.button.removeAttribute('aria-disabled');}
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
